import React, { useCallback, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { Container, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { RootState } from 'slices';
import { Formik, FormikProps } from 'formik';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  setActiveInventoryIndex,
  setCurrentPage,
  setInventoryDetailsModalOpen,
  setShowAllValidateInventoryErrors,
} from 'slices/productInventory/reducer';
import InventoryDetailsForm from './InventoryDetailsForm';
import { EditInventoryDetailsForm } from 'types/product/productInventoryTypes';

const InventoryDetailsModal = ({
  _fetchAllProducts,
}: {
  _fetchAllProducts: () => void;
}) => {
  const { t } = useTranslation();
  const dispatch: ThunkDispatch<RootState, void, Action> = useDispatch();

  const formikRef = useRef<FormikProps<EditInventoryDetailsForm>>(null);

  const productInventoryState = useSelector(
    (state: RootState) => state.ProductInventory
  );
  const { InventoryDetailsModal } = productInventoryState;

  const toggleModal = useCallback(
    (index: number | null = null) => {
      dispatch(
        setInventoryDetailsModalOpen(
          !InventoryDetailsModal.inventoryDetailsModalOpen
        )
      );
      dispatch(setActiveInventoryIndex(index));
    },
    [InventoryDetailsModal.inventoryDetailsModalOpen, dispatch]
  );

  const closeModal = () => {
    toggleModal(null);
    dispatch(setCurrentPage(0));
  };

  useEffect(() => {
    if (formikRef.current && formikRef.current.errors) {
      const errorKeys = Object.keys(formikRef.current.errors);
      if (errorKeys.length > 0) {
        const firstErrorField = document.querySelector(
          `[name="${errorKeys[0]}"]`
        ) as HTMLInputElement | null;

        if (
          firstErrorField !== null &&
          firstErrorField.type === 'hidden' &&
          firstErrorField.name === 'category'
        ) {
          const relatedElement = document.querySelector(
            '#react-select-2-input'
          ) as HTMLInputElement | null;

          if (relatedElement) {
            relatedElement.focus();
          }
        } else {
          if (firstErrorField) firstErrorField.focus();
        }
      }
    }
  }, [formikRef, InventoryDetailsModal.countSubmit]);

  return (
    <React.Fragment>
      <div className={`page-content`}>
        <Container fluid>
          <Modal
            size="lg"
            // style={{ maxWidth: '960px', width: 'auto' }}
            isOpen={InventoryDetailsModal.inventoryDetailsModalOpen}
            toggle={() => {
              closeModal();
              dispatch(setShowAllValidateInventoryErrors(false));
            }}
            backdrop={'static'}
            centered
          >
            <ModalHeader
              className="bg-light p-3"
              toggle={() => {
                closeModal();
                dispatch(setShowAllValidateInventoryErrors(false));
              }}
            >
              {t('Inventory Count Details')}
            </ModalHeader>
            <ModalBody>
              <Formik<EditInventoryDetailsForm>
                initialValues={InventoryDetailsModal.InventoryDetailsValues}
                onSubmit={async (_values: EditInventoryDetailsForm) => {}}
                enableReinitialize={true}
                innerRef={formikRef}
              >
                {(formik) => (
                  <form noValidate className="" onSubmit={formik.handleSubmit}>
                    <InventoryDetailsForm formik={formik} dispatch={dispatch} />
                  </form>
                )}
              </Formik>
            </ModalBody>
          </Modal>
        </Container>
        <ToastContainer closeButton={false} limit={1} />
      </div>
    </React.Fragment>
  );
};
export default InventoryDetailsModal;
